import { expVal } from '@atlassian/jira-feature-experiments';

const EnableWorkItemForQuadraticReleaseRelayProvider = {
	get(): boolean {
		return expVal('work_item_for_quadratic', 'isEnabled', false);
	},
};

export default EnableWorkItemForQuadraticReleaseRelayProvider;
